export const classification = [
  {
    group: 'Grupo J',
    standings: [
      {
        position: 1,
        team: {
          teamId: 'CIV',
          name: 'Costa de Marfil',
          shortName: 'Costa de Marfil',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
          isPlaceholder: false,
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 4, description: 'Goal difference' },
        },
      },
      {
        position: 2,
        team: {
          teamId: 'AUT',
          name: 'Austria',
          shortName: 'Austria',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUT_flag.png',
          isPlaceholder: false,
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: 1, description: 'Goal difference' },
        },
      },
      {
        position: 3,
        team: {
          teamId: 'QAT',
          name: 'Qatar',
          shortName: 'Qatar',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/QAT_flag.png',
          isPlaceholder: false,
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -2, description: 'Goal difference' },
        },
      },
      {
        position: 4,
        team: {
          teamId: 'JOR',
          name: 'Jordania',
          shortName: 'Jordania',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/JOR_flag.png',
          isPlaceholder: false,
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
    ],
  },
];
